import { createRequestActionTypes } from '../../shared/utility'

export const RSAActions = {
    fetchRSAKeyList: createRequestActionTypes('FETCH_RSA_KEY_LIST'),
    createRSAKey: createRequestActionTypes('CREATE_RSA_KEY'),
    downloadRSAPublicKey: createRequestActionTypes('DOWNLOAD_RSA_PUBLIC_KEY'),
    expireKeyPair: createRequestActionTypes('EXPIRE_KEY_PAIR'),
}